module.exports = __webpack_public_path__ + "static/media/clear_board.2f1a5728.gif";